module.exports = __webpack_public_path__ + "img/img03.4d0c9704.svg";